// extracted by mini-css-extract-plugin
module.exports = {"heading":"AdContactBtnGroup_heading__2xo_r","btn":"AdContactBtnGroup_btn__WKUa-","btnText":"AdContactBtnGroup_btnText__2hv6b","sending":"AdContactBtnGroup_sending__1sYXB"};